<template>
  <v-combobox
    v-model="chips"
    :items="items"
    chips
    clearable
    label="Select Tag or type it and hit enter to confirm"
    multiple
    :outlined="outlined"
    @change="onChange"
    hide-details
  >
    <template v-slot:selection="{ attrs, item, select, selected }">
      <v-chip
        v-bind="attrs"
        :input-value="selected"
        close
        @click="select"
        @click:close="remove(item)"
      >
        <strong>{{ item }}</strong
        >&nbsp;
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
import gql from "graphql-tag";
import EventBus from "../../../store/event-bus";
const TAGS_QUERY = gql`
  query supplierTags($owner: GtTagOwner) {
    tags(filter: { owner_eq: $owner }) {
      edges {
        node {
          name
        }
      }
    }
  }
`;
export default {
  name: "tags-select",
  props: {
    value: {
      type: String,
      default: () => "",
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    owner: {
      type: String,
      default: () => "SUPPLIER",
    },
  },

  data() {
    return {
      chips: [],
    };
  },

  watch: {
    value(newTags) {
      this.chips = [];
      if (newTags && newTags != "") this.chips = newTags.split(" ");
    },
  },

  computed: {
    items() {
      return this.tags && this.tags.edges
        ? [...this.tags.edges.map((t) => t.node.name)].sort()
        : [];
    },
  },

  methods: {
    selectTags() {
      if (this.value && this.value != "")
        this.chips = this.value.split(" ").sort();
    },
    onChange() {
      this.$emit("input", this.chips.sort().join(" "));
    },
    remove(item) {
      //this.chips.splice(this.chips.indexOf(item), 1);
      this.chips = [...this.chips.filter((chip) => chip != item)];
      this.onChange();
    },
  },

  apollo: {
    tags: {
      query: TAGS_QUERY,
      variables() {
        return {
          owner: this.owner,
        };
      },
      result(payload) {
        this.selectTags();
      },
      fetchPolicy: "network-only",
    },
  },
  mounted() {
    EventBus.$on("update-tags", () => {
      if (this.$apollo.queries.tags != null) {
        this.$apollo.queries.tags.refetch();
      }
    });
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/TagsSelect.vue